import React from 'react';

type Props = {
  className?: string;
  width?: string;
  height?: string;
};

const StarIcon: React.FC<Props> = ({ className, width = '16', height = '16' }) => (
  <svg className={className} width={width} height={height} viewBox="0 0 24 24" fill="#f6ca47" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <filter id="starShadow" x="-50%" y="-50%" width="200%" height="200%">
        <feDropShadow dx="0" dy="1" stdDeviation="1" floodColor="rgba(0,0,0,0.3)" />
      </filter>
    </defs>
    <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="#f6ca47" filter="url(#starShadow)" />
  </svg>
);

export default StarIcon;
